import React from 'react';
import { useQuery } from '../../app/utils/hooks';
import { agent } from '../../app/api/agent';
import { toast } from 'react-toastify';
import { Button, Header, Icon, Segment } from 'semantic-ui-react';

const RegisterSuccess: React.FC = () => {
  const email = useQuery().get('email') as string;

  async function confirmEmailResend() {
    try {
      await agent.Account.resendEmailConfirm(email);
      toast.success('Verification email resent - please check your email');
    } catch (error) {
      console.error(error);
    }
  }

  return (
    <Segment placeholder textAlign="center">
      <Header icon color="green">
        <Icon name="check" />
        Successfully registered!
      </Header>
      <p>One more step left:</p>
      <p>
        Please check your email (including junk folder) for the verification
        email
      </p>
      {email && (
        <>
          <p>
            Did not receive the email? Click the button below to resend the
            email
          </p>
          <Button
            primary
            onClick={confirmEmailResend}
            content="Resend email"
            size="huge"
          />
        </>
      )}
    </Segment>
  );
};

export { RegisterSuccess };
